import React, { type ReactNode } from 'react'

import { trackExternalLinkEvent } from 'utils/analytics'

type Props = {
	to: string
	onClick?: () => void
	children: ReactNode
	eventCategory: string
	className?: string
}
export default function ExternalLink(props: Props): React.ReactNode {
	const { to, eventCategory, ...rest } = props

	const handleOnClick = (event: React.SyntheticEvent<HTMLAnchorElement>) => {
		event.persist()
		if (props.onClick) {
			props.onClick()
		}
		trackExternalLinkEvent({ link: event.currentTarget.href, eventCategory })
	}
	return (
		<a {...rest} href={to} onClick={handleOnClick} target='_blank' rel='noopener noreferrer'>
			{props.children}
		</a>
	)
}
